export const RECEIPT_TYPES = Object.freeze({
  CARRIER_MEMBER: 'carrier_member',
  CARRIER_MOBILE_BARCODE: 'carrier_mobile_barcode',
  DONATE: 'donate',
  B2B: 'b2b',
  CARRIER_CITIZEN_DIGITAL: 'carrier_citizen_digital',
  PAYMENT_CARRIER: 'payment_carrier',
});

export const RECEIPT_NAME = Object.freeze({
  [RECEIPT_TYPES.CARRIER_MEMBER]: '會員載具',
  [RECEIPT_TYPES.CARRIER_MOBILE_BARCODE]: '手機條碼載具',
  [RECEIPT_TYPES.DONATE]: '發票捐贈',
  [RECEIPT_TYPES.B2B]: '統編發票',
  [RECEIPT_TYPES.CARRIER_CITIZEN_DIGITAL]: '自然人憑證載具',
});

export const RECEIPT_NAME_NONE_MEMBER = Object.freeze({
  [RECEIPT_TYPES.CARRIER_MEMBER]: '信箱載具',
  [RECEIPT_TYPES.CARRIER_MOBILE_BARCODE]: '手機條碼載具',
  [RECEIPT_TYPES.DONATE]: '發票捐贈',
  [RECEIPT_TYPES.B2B]: '統編發票',
  [RECEIPT_TYPES.CARRIER_CITIZEN_DIGITAL]: '自然人憑證載具',
  [RECEIPT_TYPES.PAYMENT_CARRIER]: '平台載具',
});
